<template>
  <div>
    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('物流')">新增
      </el-button>
      <el-table :data="tableData" border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="expressName" label="物流名称"/>
        <el-table-column prop="expressType" label="物流方式"/>
        <el-table-column prop="expressNumber" label="物流编码"/>
        <el-table-column prop="expressPrice" label="充值单价"/>
        <el-table-column prop="expressSinglePrice" label="成本"/>
        <el-table-column prop="isStartUse" label="是否启用">
          <template slot-scope="scope">
            <el-switch
                active-text="是"
                inactive-text="否"
                v-model="scope.row.isStartUse"
                @change=changeStatus(scope.$index,scope.row)>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit"
                       @click="handleEdit(scope.$index, scope.row,'修改物流信息')">
              编辑
            </el-button>
            <el-button size="mini" type="success"
                       @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="dialogForm" ref="dialogForm"
               :rules="dialogFormRules" label-width="260px">
        <el-row>
          <el-col :span="18">
            <el-form-item label="快递列表" prop="expressType">
              <el-select value-key="id" v-model="dialogForm.expressKuaidiType" clearable placeholder="请选择" @change="expressKuaidiChange">
                <el-option
                    v-for="item in dialogExpressType"
                    :key="item.id"
                    :label="item.subname"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼品列表" prop="expressGiffer">
              <el-select value-key="id" v-model="dialogForm.expressGiffer" clearable placeholder="请选择" @change="expressGifferChange">
                <el-option
                    v-for="item in dialogExpressGiffers"
                    :key="item.id"
                    :label="item.goodsName"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库列表" prop="cang">
              <el-select value-key="id" v-model="dialogForm.cang" clearable placeholder="请选择">
                <el-option
                    v-for="item in dialogExpressCangs"
                    :key="item.id"
                    :label="item.cangName"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流方式名称" prop="expressName">
              <el-input v-model="dialogForm.expressName"></el-input>
            </el-form-item>
            <el-form-item label="物流编码" prop="expressNumber">
              <el-input v-model="dialogForm.expressNumber"></el-input>
            </el-form-item>
            <el-form-item label="充值单价" prop="expressPrice">
              <el-input v-model="dialogForm.expressPrice" type="number"></el-input>
            </el-form-item>
            <el-form-item label="成本" prop="expressSinglePrice">
              <el-input v-model="dialogForm.expressSinglePrice" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="isStartUse">
              <el-radio-group v-model="dialogForm.isStartUse">
                <el-radio :label="true">启用</el-radio>
                <el-radio :label="false">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--
            <div v-if="dialogForm.expressType=='12321' || dialogForm.expressType=='31231'">
              <el-form-item label="AppKey" prop="AppKey">
                <el-input v-model="dialogForm.appKey"></el-input>
              </el-form-item>
              <el-form-item label="AppSecret" prop="AppSecret">
                <el-input v-model="dialogForm.appSecret"></el-input>
              </el-form-item>
              <div v-if="dialogForm.expressType=='12321'">
                <el-form-item label="空包类型" prop="nullPackgeType">
                  <el-input v-model="dialogForm.nullPackgeType"></el-input>
                </el-form-item>
              </div>
              <div v-if="dialogForm.expressType=='31231'">
                <el-form-item label="礼品ID" prop="giftId">
                  <el-input v-model="dialogForm.giftId"></el-input>
                </el-form-item>
              </div>
            </div>
            <div v-if="dialogForm.expressType=='53213'">
              <el-form-item label="Api地址" prop="apiAddress">
                <el-input v-model="dialogForm.apiAddress"></el-input>
              </el-form-item>
              <el-form-item label="AppKey" prop="AppKey">
                <el-input v-model="dialogForm.appKey"></el-input>
              </el-form-item>
              <el-form-item label="AppSecret" prop="AppSecret">
                <el-input v-model="dialogForm.appSecret"></el-input>
              </el-form-item>
              <el-form-item label="模版名称" prop="modelName">
                <el-select v-model="dialogForm.modelName" clearable placeholder="请选择">
                  <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.taskName"
                      :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="dialogForm.expressType == '21312'">
              <el-form-item label="Api地址" prop="apiAddress">
                <el-input v-model="dialogForm.apiAddress"></el-input>
              </el-form-item>
              <el-form-item label="会员名" prop="vipName">
                <el-input v-model="dialogForm.vipName"></el-input>
              </el-form-item>
              <el-form-item label="礼品编码" prop="giftId">
                <el-input v-model="dialogForm.giftId"></el-input>
              </el-form-item>
            </div>
            <div v-if="dialogForm.expressType == '42135'">
              <el-form-item label="礼品选择" prop="giftSelected">
                <el-select v-model="dialogForm.giftSelected" clearable placeholder="请选择">
                  <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.taskName"
                      :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="AppUrl" prop="appUrl">
                <el-input v-model="dialogForm.appUrl"></el-input>
              </el-form-item>
              <el-form-item label="AppKey" prop="AppKey">
                <el-input v-model="dialogForm.appKey"></el-input>
              </el-form-item>
              <el-form-item label="AppSecret" prop="AppSecret">
                <el-input v-model="dialogForm.appSecret"></el-input>
              </el-form-item>
              <el-form-item label="礼品ID" prop="giftId">
                <el-input v-model="dialogForm.giftId"></el-input>
              </el-form-item>
              <el-form-item label="快递(1=百世汇通 2=圆通)" prop="express2ex">
                <el-input v-model="dialogForm.express2ex"></el-input>
              </el-form-item>
              <el-form-item label="平台(1=淘宝 2=拼多多 3京东 4苏宁)" prop="expressPlateform">
                <el-input v-model="dialogForm.expressPlateform"></el-input>
              </el-form-item>
              <el-form-item label="仓库(1杭州仓库 2常熟仓库)" prop="warehouse">
                <el-input v-model="dialogForm.warehouse"></el-input>
              </el-form-item>
            </div>
            -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">确 定</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {
  getAllExpressType,
  getAllExpress,
  addExpress,
  updateExpress,
  queryKuaidiList, queryGifferList, queryCangList, deleteExpress
} from "../../api/b2cbusiness/b2c_express";
import {deleteB2cGoods} from "../../api/b2cbusiness/b2c_goods";

export default {
  name: "ExpressPatternlist",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryForm: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      baseExpressPrice: 0.0,
      dialogExpressType: [],
      dialogExpressGiffers: [],
      dialogExpressCangs: [],
      dialogFormVisible: false,
      dialogRefName: "dialogForm",
      dialogTitle: "",
      dialogForm: {
        expressKuaidiType:null,
        expressGiffer: null,
        cang: null,
        expressName: null,
        expressNumber: null,
        expressPrice: null,
        isStartUse: true
      },
      dialogFormRules: {
        expressName: [
          {required: true, message: '请输入物流名称', trigger: 'blur'},
        ],
        expressNumber: [
          {required: true, message: '请输入物流编码', trigger: 'blur'},
          {pattern: /^[A-Za-z0-9]+$/, message: '只能包含英文、数字', trigger: 'blur'}
        ],
        expressPrice: [
          {required: true, message: '请输入价格', trigger: 'blur'},
        ]
      },
    }
  },
  mounted() {
    queryKuaidiList().then(res => {
      if (res.success){
        this.dialogExpressType = res.data;
      }
    });
  },
  methods: {
    expressGifferChange(value){
      this.dialogForm.expressSinglePrice = this.baseExpressPrice + value.price;
    },
    expressKuaidiChange(val){
      let thant = this;
      this.dialogForm.expressKuaidiType = val;
      this.baseExpressPrice = val.price;
      queryGifferList(val.id).then(res=>{
        if (res.success){
          thant.dialogExpressGiffers = res.data;
          if (thant.dialogExpressGiffers.length == 1){
            thant.dialogForm.expressGiffer = thant.dialogExpressGiffers[0];
            thant.dialogForm.expressSinglePrice = thant.baseExpressPrice + thant.dialogExpressGiffers[0].price;
          }
        }
      });
      queryCangList(val.cang).then(res=>{
        if (res.success){
          thant.dialogExpressCangs = res.data;
          if (thant.dialogExpressCangs.length == 1){
            thant.dialogForm.cang = thant.dialogExpressCangs[0];
          }
        }
      });
    },
    getData() {
      getAllExpress({pageNum: this.pagination.pageNum, pageSize: this.pagination.pageSize,})
          .then(res => {
            this.setData(res)
      })
    },
    updateData() {
      updateExpress(this.dialogForm)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
            this.submitQueryForm();//修改之后，重新查询table
            this.handleCloseDialog();
          })
    },
    addData() {
      addExpress(this.dialogForm).then(res => {
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
      })
    },
    deleteData(row){
      this.$confirm("确定删除?")
          .then(_ => {
            deleteExpress(row.id)
                .then(res => {
                  this.submitQueryForm();//删除之后，重新查询table
                  this.$message({message: res.data, type: 'success'});
                }).catch(err => {
              this.$message({message: err.message, type: 'success'});
            })
          });
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.dialogTitle = "新增物流"
      this.resetDialogForm()
    },
    handleEdit(index, row,dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      this.expressKuaidiChange(this.dialogForm.expressKuaidiType);
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
    setData(pageinfo) {
      if (pageinfo.success) {
        console.log(pageinfo)
        this.tableData = pageinfo.data.records
        this.pagination.pageSize = pageinfo.data.size
        this.pagination.total = pageinfo.data.total
        this.$forceUpdate();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    getAllExpress({pageNum: 1, pageSize: 20,}).then(res => {
      next(vm => {
        vm.setData(res)
      });
    });
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
